import { DialogService, GridAction } from '@eforall/dashboard';
import { AccTeamDialog } from '../../../../../../../../ui/widget';
import { AcceleratorAreaService } from '../../../../../accelerator-area.service';
import { AccTeam } from '../acc-teams-view.part';

export function getActions(dialogService: DialogService, areaService: AcceleratorAreaService): GridAction<AccTeam>[] {

	const actions: GridAction<AccTeam>[] = [
		{
			iconClass: 'fa-regular fa-file-lines',
			label: 'View Team Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(AccTeamDialog, { data: { accTeamId: rows[0]!.accTeamId } }, 900, 900);
				await areaService.reloadData(); // TODO: optimize to avoid full reload if no changes
			}
		}
	];

	return actions;
}